import * as React from "react";

function SvgIcons8OutgoingData(props, ref) {
  return (
    <svg viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path d="M22.188 2.281L20.78 3.72 25.063 8H4v2h21.063l-4.282 4.281 1.407 1.438L28.905 9zM8 20c-1.293 0-2.395.844-2.813 2H2v2h3.188c.417 1.156 1.519 2 2.812 2s2.395-.844 2.813-2h2.374c.418 1.156 1.52 2 2.813 2 1.293 0 2.395-.844 2.813-2h2.375c.417 1.156 1.519 2 2.812 2s2.395-.844 2.813-2H30v-2h-3.188c-.417-1.156-1.519-2-2.812-2s-2.395.844-2.813 2h-2.375c-.417-1.156-1.519-2-2.812-2s-2.395.844-2.813 2h-2.374c-.418-1.156-1.52-2-2.813-2zm0 2c.563 0 1 .438 1 1 0 .563-.438 1-1 1-.563 0-1-.438-1-1 0-.563.438-1 1-1zm8 0c.563 0 1 .438 1 1 0 .563-.438 1-1 1-.563 0-1-.438-1-1 0-.563.438-1 1-1zm8 0c.563 0 1 .438 1 1 0 .563-.438 1-1 1-.563 0-1-.438-1-1 0-.563.438-1 1-1z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8OutgoingData);
